import { HydraUIAPIClient } from '@customerio/hydra-ui-api';
import { getAuthHeaders } from './auth-headers';
import { getApiBaseUrl, getUsApiBaseUrl } from './base-url';
import { recordRumRequest } from '@/services/rum';

export const hydraUiApi = new HydraUIAPIClient({
  baseUrl: getApiBaseUrl,
  fetchOptions: { credentials: 'include' },
  headers: getAuthHeaders,
  onRequestTiming: recordRumRequest,
});

/**
 * Variant of {@link hydraUiApi} pinned to the US data center. Use it only for endpoints that are
 * served exclusively from, or must be routed to, the US region; every other endpoint must use
 * {@link hydraUiApi}. Current callers:
 *
 * - the SSO/SCIM configuration endpoints, which are US-only (opsbugs/4138);
 * - the contracts-sales support inboxes, and the copilot account-management tool that posts to the
 *   same premium inbox, so every sales lead lands in one queue rather than depending on the account's
 *   region running its own support-ticket consumer.
 *
 * The remaining support paths (`support.create`, `support.feedback`, `support.sign`) still use the
 * regional client and are a known inconsistency — see the note in `use-submit-contracts-sales.ts`.
 */
export const hydraUiApiUs = new HydraUIAPIClient({
  baseUrl: getUsApiBaseUrl,
  fetchOptions: { credentials: 'include' },
  headers: getAuthHeaders,
  onRequestTiming: recordRumRequest,
});
